class gtmEvents {
  constructor() {
    document.querySelectorAll('[data-action="gtm-send-added"]').forEach((buttonEl) => {
      buttonEl.addEventListener("click", (e) => this.addedToCart(e));
    });
    
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-action="gtm-send-viewed"]')) {
        this.selectItem(e);
      }
    });
   
    if (document.body.classList.contains('template-product')) {
      this.viewedItemPDP();
    }
  }

   initViewListeners(container = document) {
    container.querySelectorAll('[data-action="gtm-send-viewed"]').forEach(el => {
      if (!el.hasAttribute('data-gtm-listener')) {
        el.addEventListener('click', (e) => this.selectItem(e));
        el.setAttribute('data-gtm-listener', 'true');
      }
    });
  }

  selectItem(event){
    event.preventDefault();
    const productEl = event.target.closest('[data-product]');    
    if (!productEl) {
      console.warn('Nije pronađen parent sa data-product');
      return;
    }

    const settings = JSON.parse(productEl.dataset.settings);

    const productId = settings.item_id; 
    const sku = settings.item_sku; 
    const name = settings.item_name;
    const price = settings.item_price || 0;
    const quantity = settings.item_quantity || 1;
    const listName = settings.list_name;
    const tag = settings.item_tag || '';

    window.dataLayer = window.dataLayer || [];

    if (tag === 'olitalia') {
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          content_list_name: listName,
          content_type: 'product',
          currency: 'RSD',
          value: price * quantity,
          items: [
            {
              content_id: productId, 
              content_sku: sku,
              contents: name,
              value: price,
              quantity: quantity,
              tag: tag
            }
          ]
        }
      })
    };

    // console.log(window.dataLayer);

    const href = event.target.href || event.target.closest('a')?.href;
    if (href) {
      setTimeout(() => {
        window.location.href = href;
      }, 200); 
    }
    
  }

  viewedItemPDP() {
    const productEl = document.querySelector('[data-product]');
    if (!productEl) return;

    const settings = JSON.parse(productEl.dataset.settings);

    const productId = settings.item_id;
    const sku = settings.item_sku;
    const name = settings.item_name;
    const price = settings.item_price || 0;
    const quantity = settings.item_quantity || 1;
    const tag = settings.item_tag || '';

    window.dataLayer = window.dataLayer || [];
    
    if (tag === 'olitalia') {
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          content_type: 'product',
          currency: 'RSD',
          value: price * quantity,
          items: [
            {
              content_id: productId,
              contents: name,
              content_sku: sku,
              price: price,
              quantity: quantity,
              tag: tag
            }
          ]
        }
      })
    };

    // console.log('[GTM] view_item', window.dataLayer);
  }

  addedToCart(event) {
    let target = event.target.closest('[data-product]');
    if (!target) return;

    const settings = JSON.parse(target.dataset.settings);

    const productId = settings.item_id; 
    const sku = settings.item_sku; 
    const name = settings.item_name;
    const price = settings.item_price || 0;
    const quantity = settings.item_quantity || 1;
    const tag = settings.item_tag || '';

    window.dataLayer = window.dataLayer || [];

    if (tag === 'olitalia') {
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          content_type: 'product',
          currency: 'RSD',
          value: price * quantity,
          items: [
            {
              content_id: productId, 
              content_sku: sku,
              contents: name,
              price: price,
              quantity: quantity,
              tag: tag
            }
          ]
        }
      })
    };

    // console.log(window.dataLayer);
  }
}

const gtmInstance = new gtmEvents();
